import { FunctionComponent } from "react";
import { LocationIcon } from "@icons/LocationIcon";
import { Text } from "@ui-kit/Text/Text";
import { Maneuver } from "@lib/maps/@google/types";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";

import "./DirectionListItem.css";

interface DirectionItemType {
  key: number;
  manuever: "destination" | Maneuver;
  subtitle: string;
  title: string;
}

const DirectionItem: FunctionComponent<{ item: DirectionItemType }> = ({
  item,
}) => {
  return (
    <div className="direction-item-component">
      {item.manuever === "destination" ? (
        <LocationIcon color={colors.black} />
      ) : null}
      <div className="direction-item-content-container">
        <div>
          <Text style={{ fontWeight: 600 }} variant="fontHeadingXsmall">
            {item.title}
          </Text>
        </div>
        <div className="subtitle-container">
          <Text variant="fontBodySmall" color={colors.neutral500}>
            {item.subtitle}
          </Text>
          {item.manuever !== "destination" ? <div className="line" /> : null}
        </div>
      </div>
    </div>
  );
};

export { DirectionItem };
export type { DirectionItemType };
